import { useEffect, useMemo, useState } from "react";

import {
  DAY_TO_MILISECONDS,
  HOUR_TO_MILISECONDS,
  MINUTE_TO_MILISECONDS,
  SECOND_TO_MILISECONDS,
} from "../constants/cyber";

const useCountdown = (targetDate) => {
  const countDownDate = useMemo(() => new Date(targetDate).getTime(), [
    targetDate,
  ]);

  const [countDown, setCountDown] = useState(() =>
    Math.max(countDownDate - Date.now(), 0)
  );

  useEffect(() => {
    if (countDown <= 0) return;
    const interval = setInterval(() => {
      setCountDown((prev) => {
        const newTime = Math.max(prev - 1000, 0);
        if (newTime === 0) clearInterval(interval);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [countDown]);

  return useMemo(
    () => ({
      days: Math.floor(countDown / DAY_TO_MILISECONDS),
      hours: Math.floor((countDown % DAY_TO_MILISECONDS) / HOUR_TO_MILISECONDS),
      minutes: Math.floor(
        (countDown % HOUR_TO_MILISECONDS) / MINUTE_TO_MILISECONDS
      ),
      seconds: Math.floor(
        (countDown % MINUTE_TO_MILISECONDS) / SECOND_TO_MILISECONDS
      ),
      show: countDown > 0,
    }),
    [countDown]
  );
};

export { useCountdown };
